const termsEN = {
	title: "Terms & Conditions",
	lastUpdated: "Effective Date",
	close: "Close",

	intro: {
		heading: "1) Introduction & Agreement",
		p1: "Reserva Sin Fila (“we”, “our”, or “us”) provides an online platform that enables clients to book barbershop and beauty appointments and helps professionals manage schedules and communications (“Services”).",
		p2: "By accessing or using our website, app, or related services, you agree to be bound by these Terms & Conditions (“Terms”) and our Privacy Policy. If you do not agree, do not use the Services.",
		p3: "Important: Reserva Sin Fila is a platform only. We are not the service provider, and we do not guarantee the quality, safety, legality, or availability of any service.",
	},

	eligibility: {
		heading: "2) Eligibility & Use of Service",
		list: [
			"Users must have the legal capacity to enter into a contract in their jurisdiction.",
			"If you are under the age of majority in your jurisdiction, you may only use the Services with the consent of a parent or legal guardian, who agrees to these Terms on your behalf.",
			"You agree to use the Services only for lawful purposes and in accordance with these Terms.",
			"We may modify, suspend, or discontinue any part of the Services at any time.",
		],
	},

	accounts: {
		heading: "3) Accounts & Security",
		list: [
			"You are responsible for maintaining the confidentiality of your login credentials and all activities under your account.",
			"You agree to provide accurate, current, and complete information and to keep it updated.",
			"Notify us immediately of any unauthorized use or security breach.",
		],
	},

	bookings: {
		heading: "4) Bookings, Cancellations & Payments",
		p1: "The Services facilitate bookings between clients and independent barbers/shops. All payments for services are made directly between clients and barbers/shops. Reserva Sin Fila does not process or handle user payments.",
		p2: "Businesses pay Reserva Sin Fila fees for using the platform (subscription, service, or transaction-based fees).",
		p3: "Each shop may set its own policies for pricing, deposits, cancellations, and no-shows. You agree to review and comply with these policies shown during booking.",
		p4: "We may assist with disputes, but we do not guarantee outcomes.",
		p5: "Reserva Sin Fila does not guarantee error-free operation of the platform and is not liable for failed or delayed bookings due to technical issues.",
	},

	proResponsibilities: {
		heading: "5) Professional / Business Responsibilities",
		list: [
			"Barbers/shops are independent and solely responsible for compliance with applicable laws, licenses, taxes, and safety standards.",
			"Businesses must ensure availability, pricing, services, and policies shown on the platform are accurate and updated.",
			"Businesses are responsible for their staff’s conduct and for delivering the booked services.",
			"Businesses cannot offer or list illegal or illicit services.",
		],
	},

	acceptableUse: {
		heading: "6) Acceptable Use / Prohibited Conduct",
		list: [
			"Engage in unlawful, harmful, fraudulent, or misleading activities.",
			"Interfere with the operation of the Services or attempt to access unauthorized areas.",
			"Copy, scrape, or reverse engineer the Services except as permitted by law.",
			"Post content that is illegal, offensive, defamatory, spammy, or infringes third-party rights.",
		],
	},

	userContent: {
		heading: "7) User Content",
		p1: "Users retain ownership of content they submit (reviews, comments, feedback), but grant Reserva Sin Fila a worldwide, royalty-free, non-exclusive license to host, display, and distribute content for the purpose of operating the Services.",
		p2: "Content must comply with Section 6 above.",
	},

	ip: {
		heading: "8) Intellectual Property",
		p1: "The Services, including software, text, graphics, logos, and other content, are owned by or licensed to Reserva Sin Fila and are protected by intellectual property laws.",
		p2: "Except as expressly permitted, no rights are granted to you to copy, reproduce, or use our IP.",
	},

	disclaimer: {
		heading: "9) Disclaimer of Warranties",
		p1: "THE SERVICES ARE PROVIDED “AS IS” AND “AS AVAILABLE” WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.",
		p2: "We strive to keep the Services available, but we can not guarantee uninterrupted or error-free access. Temporary service interruptions may occur due to maintenance, upgrades, technical issues, or events beyond our control.",
	},

	liability: {
		heading: "10) Limitation of Liability",
		p1: "TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT WILL RESERVA SIN FILA OR ITS AFFILIATES BE LIABLE FOR INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, EXEMPLARY, OR PUNITIVE DAMAGES.",
		p2: "Our total liability for any claim relating to the Services will not exceed the greater of: The amount paid by the business to us in the 3 months prior to the claim.",
		p3: "Users agree that disputes with businesses are between the user and business, not Reserva Sin Fila.",
	},

	indemnity: {
		heading: "11) Indemnification",
		text: "You agree to indemnify and hold Reserva Sin Fila harmless from any claims, damages, liabilities, and expenses arising from your use of the Services, violation of these Terms, or breach of applicable law.",
	},

	termination: {
		heading: "12) Termination & Suspension",
		text: "We may suspend or terminate access to the Services at any time, with or without notice, for violation of these Terms or misuse. Termination does not affect accrued rights, fees, or indemnification obligations.",
	},

	privacy: {
		heading: "13) Privacy",
		text: "By using the Services, you consent to the collection, use, and processing of your data as described in our Privacy Policy.",
	},

	law: {
		heading: "14) Governing Law & Disputes",
		text: "These Terms are governed by the laws of the Dominican Republic.",
	},

	changes: {
		heading: "15) Changes to Terms",
		text: "We may update these Terms at any time. Continued use after changes become effective constitutes acceptance of the updated Terms.",
	},

	misc: {
		heading: "16) Miscellaneous",
		list: [
			"Entire Agreement: These Terms constitute the entire agreement between you and us.",
			"Severability: If any provision is invalid, the remainder remains in effect.",
			"No Waiver: Failure to enforce a provision does not waive future enforcement.",
			"Assignment: You may not transfer rights or obligations without our consent.",
		],
	},
};

export default termsEN;
